<template>
  <div>
    <b-container fluid class="fp-container bg-light-grey">
      <Tiedot/>
    </b-container>

    <b-container class="fp-container bg-white">
      <b-row>
        <b-col>
          <h1>Löydä ratkaisuja tarjoavia yrityksiä</h1>
        </b-col>
      </b-row>

      <b-container v-if="kayttotarkoitus !== null">
      <b-row>
        <b-col cols="12">
          <h2 class="mb-0">Valinnan mukaisia rakennuksia valmistavat yritykset</h2>
          <small>{{kayttotarkoitusLabel}}{{rakenneLabel}}</small>
        </b-col>
      </b-row>
      <b-row class="pt-3">
        <b-col v-for="(yritys, idx) in yritykset" :key="idx" cols="3" class="text-left py-2">
          <a :href="yritys.link" target="_blank">{{ yritys.name }}</a>
        </b-col>
      </b-row>
      </b-container>
    </b-container>

    <b-container fluid class="fp-container">
      <b-container>
        <b-row>
          <b-col cols="12">
            <h2>Hae yrityksiä rakennejärjestelmän perusteella</h2>
            <el-select
              v-model="rakennusosa"
              placeholder="Valitse"
              @change="searchOsaCompanies"
            >
              <el-option
                v-for="term in osaterms"
                :label="term.name"
                :value="term.slug"
                :key="term.id"
              ></el-option>
            </el-select>
          </b-col>
        </b-row>
        <b-row class="pt-3">
          <b-col v-for="(yritys, idx) in rakennusosat" :key="idx" cols="3" class="text-left py-2">
            <a :href="yritys.link" target="_blank">{{ yritys.name }}</a>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

    <b-container fluid class="fp-container bg-light-grey">
      <b-container>
        <b-row>
          <b-col cols="12">
            <h2>Yrityshaku</h2>
            <el-select
            v-model="searchslug"
            placeholder="Valitse"
            @change="searchCompanies"
          >
            <el-option
              v-for="term in searchterms"
              :label="term.name"
              :value="term.slug"
              :key="term.id"
            ></el-option>
          </el-select>
          </b-col>
        </b-row>
        <b-row class="pt-3">
          <b-col v-for="(yritys, idx) in searchresults" :key="idx" cols="3" class="text-left py-2">
            <a :href="yritys.link" target="_blank">{{ yritys.name }}</a>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import Tiedot from '../components/Tiedot'
import { kayttoResolv } from '../data/kayttotarkoitukset'
import { rakenneResolv } from '../data/rakenteet'

export default {
  name: 'Kilpailuta',
  components: {Tiedot},
  data () {
    return {
      yritykset: [],
      rakennusosat: [],
      rakennusosa: null,
      osaterms: [],
      searchterms: [],
      searchslug: null,
      searchresults: [],
      loading: false
    }
  },
  computed: {
    kayttotarkoitus: function () {
      return kayttoResolv(this.userSelection.kayttotarkoitus, 'category', null)
    },
    kayttotarkoitusLabel: function () {
      return kayttoResolv(this.userSelection.kayttotarkoitus, 'label', null)
    },
    rakenne: function () {
      return rakenneResolv(this.userSelection.rakenne, 'osat', null)
    },
    rakenneLabel: function () {
      if (this.userSelection.rakenne !== '') {
        return ', ' + rakenneResolv(this.userSelection.rakenne, 'label', null)
      }
      return null
    }
  },
  mounted: function () {
    this.loadCompanies(this.kayttotarkoitus, this.rakenne)
    this.loadTerms()
    this.loadOsaTerms()
  },
  methods: {
    loadCompanies (kayttotarkoitukset, rakenne) {
      // console.debug(kayttotarkoitukset, rakenne)
      const params = {
        rest_route: '/wp/v2/yritykset'
      }
      if (kayttotarkoitukset !== null) {
        params['filter[kayttotarkoitukset]'] = kayttotarkoitukset
      }
      if (this.userSelection.rakenne !== '') {
        params['osat'] = rakenne
      }
      // console.debug(params)
      this.loading = true
      this.fetchData(params, data => {
        this.yritykset.length = 0
        data.forEach(yritys => {
          this.yritykset.push({
            name: yritys.title.rendered,
            link: yritys.acf.website
          })
        })
      })
    },
    loadTerms () {
      const params = {
        rest_route: '/wp/v2/yrityshaku',
        per_page: 100
      }
      this.fetchData(params, data => {
        this.searchterms = data
      })
    },
    loadOsaTerms () {
      const params = {
        rest_route: '/wp/v2/osat'
      }
      this.fetchData(params, data => {
        this.osaterms = data
      })
    },
    searchCompanies () {
      const params = {
        rest_route: '/wp/v2/yritykset',
        per_page: 100
      }
      params['filter[yrityshaku]'] = this.searchslug
      this.fetchData(params, data => {
        this.searchresults.length = 0
        data.forEach(yritys => {
          this.searchresults.push({
            name: yritys.title.rendered,
            link: yritys.acf.website
          })
        })
      })
    },
    searchOsaCompanies () {
      const params = {
        rest_route: '/wp/v2/yritykset'
      }
      params['filter[osat]'] = this.rakennusosa
      this.fetchData(params, data => {
        this.rakennusosat.length = 0
        data.forEach(yritys => {
          this.rakennusosat.push({
            name: yritys.title.rendered,
            link: yritys.acf.website
          })
        })
      })
    },
    fetchData (params, callback) {
      this.axios
        .get('https://epuu.fi/', {params})
        .then(response => {
          this.loading = false
          callback(response.data)
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Kilpailuta.vue